"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = require("styled-components");
var _oxygenConfig = require("@8x8/oxygen-config");
var _oxygenUtils = require("@8x8/oxygen-utils");
var _Avatar = _interopRequireDefault(require("./Avatar"));
var _Wrapper = _interopRequireDefault(require("./Wrapper"));
var _CloseButton = _interopRequireDefault(require("./CloseButton"));
var _constants = require("../constants");
var _excluded = ["children", "theme", "testId", "isFocused"]; // @ts-check
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Tag = function Tag(_ref) {
  var children = _ref.children,
    theme = _ref.theme,
    testId = _ref.testId,
    isFocused = _ref.isFocused,
    rest = _objectWithoutProperties(_ref, _excluded);
  var action = rest.action,
    avatar = rest.avatar,
    variant = rest.variant;

  // These are forced props for the Avatar component which are not allowed to be overridden
  var avatarForcedProps = {
    hasBorder: false,
    size: (0, _oxygenUtils.useFontSize)(_constants.HEIGHT),
    showEditOverlay: false,
    userStatus: null
  };
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_Wrapper["default"], _extends({}, rest, (0, _oxygenConfig.getTestAttributes)(testId)), avatar && /*#__PURE__*/_react["default"].createElement(_Avatar["default"], _extends({}, avatar, avatarForcedProps, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_AVATAR")))), children, action && /*#__PURE__*/_react["default"].createElement(_CloseButton["default"], _extends({
    action: action,
    isFocused: isFocused,
    variant: variant
  }, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_ACTION"))))));
};
Tag.propTypes = {
  action: _propTypes["default"].func,
  avatar: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    src: _propTypes["default"].string,
    isGroup: _propTypes["default"].bool
  }),
  children: _propTypes["default"].node,
  hasError: _propTypes["default"].bool,
  isFocused: _propTypes["default"].bool,
  testId: _propTypes["default"].string,
  theme: _propTypes["default"].object.isRequired,
  variant: _propTypes["default"].oneOf(Object.keys(_constants.variants))
};
Tag.defaultProps = {
  action: undefined,
  avatar: undefined,
  children: undefined,
  hasError: false,
  isFocused: false,
  testId: 'TAG',
  variant: _constants.variants.light
};
var _default = (0, _oxygenConfig.withTheme)(Tag, 'tag');
exports["default"] = _default;